import { Component, Inject, OnInit, OnDestroy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Subscription } from 'rxjs';
import { BuisnessPromotion, ServiceList } from 'src/app/models/common';
import { ApiService } from 'src/app/providers/api.service';
import { FormControl } from '@angular/forms';
import { THIS_EXPR } from '@angular/compiler/src/output/output_ast';
import { ActivatedRoute, Router } from '@angular/router';
import { LoaderServiceService } from 'src/app/providers/loader-service.service';
import { SharedService } from 'src/app/providers/shared.service';
import { AddServiceTemplateItemComponent } from 'src/app/shared/components/add-service-template-item/add-service-template-item.component';
import { SM_CONSTANTS } from 'src/app/shared/constants/sm-constants';

@Component({
  selector: 'sm-add-product-from-inventory',
  templateUrl: './add-product-from-inventory.component.html',
  styleUrls: ['./add-product-from-inventory.component.scss']
})
export class AddProductFromInventoryComponent implements OnInit, OnDestroy {
  isEntityForeign: string = localStorage.getItem(SM_CONSTANTS.IS_ENTITY_FOREIGN)!
    selectedSlab:any = 'default'
  home_status: any = sessionStorage.getItem('home_service_status')
  shop_status: any = sessionStorage.getItem('shop_service_status')
  virtual_status: any = sessionStorage.getItem('virtual_service_status')
  isDiscountApplicable: boolean = false
  isTaxApplicable: boolean = false
  public productListData: any = {};
  isDiscount!: boolean;
  isShop: boolean = false
  isVirtual: boolean = false
  isHome: boolean = false
  isPercent!: boolean
  isAmount!: boolean
  isHomeSpecific: Boolean = false;
  isShopSpecific: Boolean = false;
  isVirtualSpecific: Boolean = false;
  entityHash: string = '';
  hideRequiredControl = new FormControl(false);
  public fileName: string = '';
  private _apiSubscription: Subscription = new Subscription();
  public editMode: boolean = false;
  public loader: boolean = false;
  public removable: boolean = true;
  public assetList: any[] = [];
  taxSlabData:any = []
  public page: number = 1;
  inventoryItems: any[] = [];
  selectedProductList: any[] = [];
  datalength!: number
  toShowTemplate: boolean = true
  constructor(
    @Inject(MAT_DIALOG_DATA) public parentData: any,
    private _apiService: ApiService,
    private _snackBar: MatSnackBar,
    private route: ActivatedRoute,
    private sharedService: SharedService,
    private loaderservice: LoaderServiceService,
    private router: Router,
    public dialog: MatDialogRef<AddServiceTemplateItemComponent>
  ) {

    this._apiSubscription = this._apiService.apiResult.subscribe((res) => {
      console.log('Response', res);
      if (res.responseType === SM_CONSTANTS.UPLOAD_RESULT) {
        console.log(res.result);
        this.assetList.push({
          assetName: this.fileName,
          url: res.result?.url,
          thumbnail: res.result?.thumbnail,
        });
        this.productListData.image_url = res.result?.url;
        this.productListData.thumb_image_url = res.result?.thumbnail;
        this.loader = false;
      }
    
      if(res.responseType === SM_CONSTANTS.RESULT_API_GET_INVENTORY_ITEMS){
       

     
        // this.inventoryItems = []
        console.log(res);
       if(res.result){
        this.datalength = res.result[0].totalCount
        // this.datalength = 0
        res.result.forEach((element:any) => {
          element.selected = false
          if(element.for_sale == 1)
            this.inventoryItems.push(element)
        });
       }
       else{
        this.datalength = 0
       }
        this.loaderservice.showLoader = false
        this.loader = false
        
      }
      if(res.responseType === SM_CONSTANTS.RESULT_API_GET_ENTITY_TAX_SLAB_DATA){
        this.taxSlabData = []
        if(res.result){
          if(!this.editMode){
            this.taxSlabData = res.result.filter((item:any) => item.tax_collection_status == 1)
            this.isTaxApplicable = true
            this.productListData.tax_collection_status = 1
            this.loaderservice.showLoader = false

          }
          else{
            this.taxSlabData = res.result.filter((item:any) => item.tax_collection_status == 1)
            let selectedTaxSlab = this.taxSlabData.filter((item:any) => item.hash_id == this.productListData.tax_slab_hash)
            this.isTaxApplicable = true
            this.productListData.tax_collection_status = 1
            this.selectedSlab = selectedTaxSlab[0] ? selectedTaxSlab[0] : 'default'
            this.loaderservice.showLoader = false
          }
        }
        else{
          this.isTaxApplicable = true
          this.loaderservice.showLoader = false
        }
      }
      if(res.responseType === SM_CONSTANTS.RESULT_API_GET_INTERNATIONAL_ENTITY_TAX_SLAB_DATA){
        this.taxSlabData = []
        if(res.result){
         if(!this.editMode){
          this.taxSlabData = res.result.filter((item:any) => item.tax_collection_status == 1)
            this.isTaxApplicable = true
            this.productListData.tax_collection_status = 1
            this.loaderservice.showLoader = false

          }
          else{
            this.taxSlabData = res.result.filter((item:any) => item.tax_collection_status == 1)
            let selectedTaxSlab = this.taxSlabData.filter((item:any) => item.hash_id == this.productListData.tax_slab_hash)
            this.isTaxApplicable = true
            this.productListData.tax_collection_status = 1
            this.selectedSlab = selectedTaxSlab[0] ? selectedTaxSlab[0].hash_id : 'default'
            this.loaderservice.showLoader = false
          }
        }
        else{
          this.isTaxApplicable = true
          this.loaderservice.showLoader = false
        }
      }
      if(res.responseType === SM_CONSTANTS.RESULT_API_ADD_EDIT_ENTITY_PRODUCT){
        if(res.result){
          this.dialog.close({msg:'success'})
        }
      }
    });


  }
  removeAsset() {
    this.productListData.image_url = '';
    this.productListData.thumb_image_url = '';
    this.assetList = [];
  }
  priceCheker(){
    
    
    if(this.isHomeSpecific && (this.productListData.home_price == null || this.productListData.home_price < 0)){
      return true
    }
    else if(this.isShopSpecific && (this.productListData.shop_price == null || this.productListData.shop_price < 0)){
      return true
    }
    else if(this.isVirtualSpecific && (this.productListData.virtual_price == null || this.productListData.virtual_price < 0)){
      return true
    }
    else if(!this.isHomeSpecific && !this.isShopSpecific && !this.isVirtualSpecific){
      return true
    }
    else{
      return false
    }
  }
  discountChecker(){
    console.log();
    
    if(this.isDiscountApplicable){
      
      if(!this.productListData.discount_type || !this.productListData.discount){
        return true
      }else{
        return false
      }
    }else{
      return false
    }
  }
  ngOnInit(): void {
    this.loader= true
    this.productListData.discountStatus = 0
    // this._apiService.getServiceTemplates(this.page);
    console.log(this.isDiscount);
    console.log(this.isPercent);
    
    
    console.log(this.parentData.data);
    this.route.queryParams.subscribe(data => {
      console.log(data.entityHash);
      this.entityHash = data.entityHash
      this._apiService.getInventoryItems(this.entityHash,this.page, '');
      
    })
    let data: any = new ServiceList();
    Object.assign(data, this.parentData.data);
    console.log(data);
    if (data.hash_id) {

      if(data.imgUrl && data.imgUrl != 'null'){
        this.assetList.push({
          assetName: data?.imgUrl
            .split('/')
            .pop()
            .substring(data.imgUrl.split('/').pop().lastIndexOf('_') + 1),
          url: data?.imgUrl,
        });
      }
      this.assetList.push({
        assetName: data?.imgUrl
          .split('/')
          .pop()
          .substring(data.imgUrl.split('/').pop().lastIndexOf('_') + 1),
        url: data?.imgUrl,
      });
      this.productListData = data;
      this.editMode = true;
    }
    if(data.shopStatus == 1){
      this.isShop = true
      let eve = {
        checked: true,
        source: {
          value: 'shop'
        }
      }
      this.change(eve);
    }
    if(data.homeStatus == 1){
      this.isHome = true
      let eve = {
        checked: true,
        source: {
          value: 'home'
        }
      }
      this.change(eve);
    }
    if(data.for_virtual == 1){
      this.isVirtual = true
      let eve = {
        checked: true,
        source: {
          value: 'virtual'
        }
      }
      this.change(eve);
    }
    if(data.discountStatus ==1){
      this.isDiscount = true
    }
    if(data.discountStatus == 0 ){
      this.isDiscount = false
    } 
    if(data.discountType == 2 ){
      this.isAmount = true
    }
    if(data.discountType == 1 ){
      this.isPercent = true
    }

    

  }
  change(event:any){
    console.log(event);
    if(event.checked == true && event.source.value == 'home'){
      this.isHomeSpecific = true
      this.productListData.home_status = 1
    } if(event.checked == true && event.source.value == 'shop'){
      this.isShopSpecific = true
      this.productListData.shop_status = 1
    } 
    if(event.checked == true && event.source.value == 'virtual'){
      this.isVirtualSpecific = true
      this.productListData.for_virtual = 1
      this.productListData.virtual_status = 1
    } 
    
    if(event.checked == false && event.source.value == 'home'){
      this.isHomeSpecific = false
      this.productListData.home_status = 0
      this.productListData.home_price = null
      this.productListData.home_discounted_price = null
    }if(event.checked == false && event.source.value == 'shop'){
      this.isShopSpecific = false
      this.productListData.shop_status = 0
      this.productListData.shop_price = null
      this.productListData.shop_discounted_price = null
    }
    if(event.checked == false && event.source.value == 'virtual'){
      this.isVirtualSpecific = false
      this.productListData.for_virtual = 0
      this.productListData.virtual_status = 0
      this.productListData.virtual_price = null
      this.productListData.virtual_price = null
      this.productListData.virtual_discounted_price = 0
      this.productListData.virtual_discounted_price = null
      
    }
    
  }

  onApp(event:any){

    if(event.target.value == 'applicable' ){
      this.productListData.discount_status = 1
    }if(event.target.value == 'not-applicable'){
      this.productListData.discount_status = 0
      this.productListData.discount = null
      this.productListData.discount_type = null
      this.isPercent = false
      this.isAmount = false
      this.productListData.home_discounted_price = null
      this.productListData.shop_discounted_price = null
      this.productListData.virtual_discounted_price = 0
      this.productListData.virtual_discounted_price = null
    }

  }

  discType(event:any){
    if(event.target.value == 'percent' ){
      this.productListData.discount_type = 1
    }if(event.target.value == 'amount'){
      this.productListData.discount_type = 2
    }

  }

  ngOnDestroy() {
    this._apiSubscription.unsubscribe();
  }

  onPost() {
    // console.log('Data', this.productListData);
 
    console.log(this.editMode);
    if (!this.editMode) {
      // this.productListData['hash_id'] = undefined;
    }

    if(this.productListData.discount_type == 1){
      if(this.productListData.home_status != 0){
        this.productListData.home_discounted_price = this.productListData.home_price - (this.productListData.discount/100)*this.productListData.home_price
      }
      if(this.productListData.shop_status != 0){
        this.productListData.shop_discounted_price = this.productListData.shop_price - (this.productListData.discount/100)*this.productListData.shop_price
      }
      if(this.productListData.virtual_status != 0 && this.productListData.for_virtual != 0){
        this.productListData.virtual_discounted_price = this.productListData.virtual_price - (this.productListData.discount/100)*this.productListData.virtual_price
      }
      
    }else if(this.productListData.discount_type == 2){
      if(this.productListData.home_status != 0){
        this.productListData.home_discounted_price = this.productListData.home_price - this.productListData.discount
      }
      if(this.productListData.shop_status != 0){
        this.productListData.shop_discounted_price = this.productListData.shop_price - this.productListData.discount
      }
      if(this.productListData.virtual_status != 0){
        this.productListData.virtual_discounted_price = this.productListData.virtual_price - this.productListData.discount
      }
      
     
    }

    if(this.productListData.home_status == 0){
      this.productListData.home_price = 0
    }
    
    if(this.productListData.shop_status == 0){
      this.productListData.shop_price = 0
    }
    if(this.productListData.virtual_status == 0){
      this.productListData.virtual_price = 0
    }
    if(this.productListData.discount_status == 0  || this.productListData.discount_status == null){
      this.productListData.discount_status == 0
      this.productListData.discount = 0
      this.productListData.home_discounted_price = 0
      this.productListData.shop_discounted_price = 0
      this.productListData.virtual_discounted_price = 0
    }
    if(this.productListData.tax_collection_status == 0  || this.productListData.tax_collection_status == null){
      this.productListData.tax_collection_status == 0
      this.productListData.tax_slab_hash = null
    }

    if(this.productListData.home_price == '-'){
      this.productListData.home_price = 0
    }
    if(this.productListData.shop_price == '-'){
      this.productListData.shop_price = 0
    }
    if(this.productListData.virtual_rate == '-'){
      this.productListData.virtual_price = 0
    }
    if(this.productListData.home_discounted_price == '-'){
      this.productListData.home_discounted_price = 0
    }
    if(this.productListData.shop_discounted_price == '-'){
      this.productListData.shop_discounted_price = 0
    }
    if(this.productListData.virtual_discounted_price == '-'){
      this.productListData.virtual_discounted_price = 0
    }

    let obj = {
      "hash_id": this.productListData.hash_id ?? null,
      "entity_hash": this.entityHash,
      "product_name": this.productListData.product_name,
      "product_desc": this.productListData.product_desc,
      "hsn_code": this.productListData.hsn_code,
      "manufacturer": this.productListData.manufacturer,
      "qty_info": this.productListData.qty_info,
      "shop_price": this.productListData.shop_price ?? 0,
      "home_price": this.productListData.home_price ?? 0,
      "virtual_price": this.productListData.virtual_price ?? 0,
      "discount": this.productListData.discount ?? 0,
      "tax_slab_hash": this.selectedSlab == 'default' ? null : this.selectedSlab,
      "image_url": this.productListData.image_url,
      "thumb_image_url": this.productListData.thumb_image_url,
      "product_type_hash": null,
      "inventory_item_hash": this.productListData.inventory_item_hash ?? null,
      "discount_status": this.productListData.discount_status,
      "discount_type": this.productListData.discount_type,
      "shop_discounted_price": Number.isNaN(this.productListData.shop_discounted_price) ? 0 :  this.productListData.shop_discounted_price ,
      "home_discounted_price": Number.isNaN(this.productListData.home_discounted_price) ? 0 :  this.productListData.home_discounted_price ,
      "virtual_discounted_price": Number.isNaN(this.productListData.virtual_discounted_price) ? 0 :  this.productListData.virtual_discounted_price ,
      "home_status": this.productListData.home_status ?? 0,
      "shop_status": this.productListData.shop_status ?? 0,
      "virtual_status": this.productListData.virtual_status ?? 0,
      "tax_collection_status": this.productListData.tax_collection_status,
      "selling_unit": this.productListData.selling_unit,
      "purchase_unit": this.productListData.purchase_unit,
      "selling_purchase_multiplier": this.productListData.selling_purchase_multiplier,
    }


    Object.keys(obj).forEach(key => {
      if ((obj as any)[key] === null || (obj as any)[key] === undefined) {
        delete (obj as any)[key];
      }
    });
  
//  let bodydata = {
//   serviceTypeInfo: this.productListData
//  }
    console.log('updated data', obj);
    this.loaderservice.showLoader = true
    this._apiService.addEditEntityProduct(obj)
    
  }

  onUploadImage(event: any) {
    this.loader = true;
    console.log(event.target.files);
    if (event.target.value === '') {
      this.loader = false;
      return;
    }
    this.fileName = event.target.files[0].name;
    let sizeinKb = +event.target.files[0].size / 1000;
    if (sizeinKb > 1021) {
      this._snackBar.open('Image size should not exceed more then 1 mb', 'Ok');
      return;
    }
    let formData: FormData = new FormData();
    formData.append('recfile', event.target.files[0]);
    this._apiService.uploadAssets(formData, 1);
  }

  selectInventoryTemplate(item:any){
    this.selectedProductList = []
    this.inventoryItems.forEach((element:any) => {
      element.selected = false
    });
    item.selected = true

    this.selectedProductList.push(item)

  }

  onSelectNext(){
    this.toShowTemplate = false

    this.productListData.product_name = this.selectedProductList[0].item_name
    this.productListData.product_desc = this.selectedProductList[0].item_desc
    this.productListData.qty_info = this.selectedProductList[0].quantity_info
    this.productListData.image_url =  this.selectedProductList[0].image_url
    this.productListData.thumb_image_url =  this.selectedProductList[0].image_thumb_url
    this.productListData.inventory_item_hash =  this.selectedProductList[0].hash_id
    this.productListData.selling_unit =  this.selectedProductList[0].selling_unit
    this.productListData.purchase_unit =  this.selectedProductList[0].purchase_unit
    this.productListData.selling_purchase_multiplier =  this.selectedProductList[0].selling_purchase_multiplier

    this.assetList = []
    if(this.selectedProductList[0].image_url && this.selectedProductList[0].image_url != 'null'){
      this.assetList.push({
        assetName: this.selectedProductList[0]?.image_url
          .split('/')
          .pop()
          .substring(this.selectedProductList[0].image_url.split('/').pop().lastIndexOf('_') + 1),
        url: this.selectedProductList[0]?.image_url,
        thumbnail: this.selectedProductList[0]?.image_thumb_url,
      });
    }

  }

  back(){
    this.toShowTemplate=true

   
  }

  seeMore(){
    this.loaderservice.showLoader = true
    this.page +=  1;
    this._apiService.getInventoryItems(this.entityHash,this.page, '');
  }

  onPageChange(ev: any) {
    console.log(ev?.pageIndex + 1);
    this.page = ev?.pageIndex + 1;
    this._apiService.getInventoryItems(this.entityHash,this.page, '');
  }

  onToggleChange(event: any){
    
    if(event.checked){
      this.isDiscountApplicable = true
      this.productListData.discount_status = 1
    }
    else if(!event.checked){
      this.isDiscountApplicable = false
      this.productListData.discount_status = 0
      this.productListData.discount = null
      this.productListData.discount_type = null
      this.isPercent = false
      this.isAmount = false
      this.productListData.home_discounted_price = null
      this.productListData.shop_discounted_price = null
    }
  }
  onToggleChangeForTax(event: any){
    this.selectedSlab = 'default'
    if(event.checked){
      this.loaderservice.showLoader = true
      if(this.isEntityForeign == '0'){
        this._apiService.getEntityTaxSlabData(this.entityHash)
      }
      else if(this.isEntityForeign == '1'){
        this._apiService.getInternationalEntityTaxSlabsData(this.entityHash)
      }
    
    }
    else if(!event.checked){
      this.isTaxApplicable = false
      this.productListData.tax_collection_status = 0
      this.productListData.tax_slab_hash = null
    }
  }

  configureTax(){
    this.dialog.close()
    this.router.navigate(['/businesses/details/tax-and-gst'],{queryParams: {entityHash: this.entityHash}})
  }

}
